(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_common/banner-helpers/assets/javascripts/dynamic-jackpots.js') >= 0) return;  svs.modules.push('/components/banner_common/banner-helpers/assets/javascripts/dynamic-jackpots.js');

'use strict';

function _regeneratorRuntime() { "use strict";  _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
var trinidadCore = isServer && require('trinidad-core').core || {};
var trindadSharedComponents = isServer && trinidadCore.components.require('content', 'shared') || {};

var gameDescription = {
  lottoOne: 'Lotto 1',
  lottoSecond: 'Lotto 2',
  dreamWin: 'Drömvinsten',
  eurojackpot: 'Eurojackpot',
  vikinglotto: 'Vikinglotto'
};

var editSchemaJackpotNameHeader = {
  lottoOne: '{{lottoJackpotOneHeader}}',
  lottoSecond: '{{lottoJackpotSecondHeader}}',
  dreamWin: '{{dreamWinJackpotHeader}}',
  eurojackpot: '{{EuroJackpotHeader}}',
  vikinglotto: '{{vikingJackpotHeader}}'
};

var editSchemaJackpotNameBody = {
  lottoOne: '{{lottoJackpotOneBody}}',
  lottoSecond: '{{lottoJackpotSecondBody}}',
  dreamWin: '{{dreamWinJackpotBody}}',
  eurojackpot: '{{EuroJackpotBody}}',
  vikinglotto: '{{vikingJackpotBody}}'
};

var getJackpotDataBannerServerSide = function () {
  var _ref = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(products, request, logger) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return trindadSharedComponents.jackpots.getJackpots({
            request: request,
            products: products,
            logger: logger
          });
        case 3:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          logger.info('Failed to get jackpots serverside', _context.t0, request);
        case 9:
          return _context.abrupt("return", []);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function getJackpotDataBannerServerSide(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var getJackpotDataBannerClientSide = function () {
  var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(products, logger) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return svs.content.shared.getJackpots(products);
        case 3:
          return _context2.abrupt("return", _context2.sent);
        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](0);
          logger.info('Failed to get jackpots clientside', _context2.t0);
        case 9:
          return _context2.abrupt("return", []);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return function getJackpotDataBannerClientSide(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var getJackpotDataBanner = function () {
  var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3(request, logger) {
    var products;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          products = ['lotto', 'eurojackpot', 'vikinglotto'];
          if (!isServer) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", getJackpotDataBannerServerSide(products, request, logger));
        case 3:
          return _context3.abrupt("return", getJackpotDataBannerClientSide(products, logger));
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getJackpotDataBanner(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var jackpotAmountTextFormatted = function jackpotAmountTextFormatted(bannerText, schemaJackpotName, jackpotAmountText) {
  if (bannerText.indexOf(schemaJackpotName) === 0) {
    return jackpotAmountText.charAt(0).toUpperCase() + jackpotAmountText.slice(1);
  }
  return jackpotAmountText;
};

var replaceEditSchemaValuesToDynamic = function replaceEditSchemaValuesToDynamic(schemaJackpotName, bannerText, jackpotAmountText) {
  return bannerText.replaceAll(schemaJackpotName, jackpotAmountTextFormatted(bannerText, schemaJackpotName, jackpotAmountText));
};

var setDynamicValues = function setDynamicValues(reformattedText, jackpotDescription, schemaJackpotName, jackpotAmountText) {
  var replaceValues = function replaceValues(schemaName) {
    return replaceEditSchemaValuesToDynamic(schemaName, reformattedText, jackpotAmountText);
  };
  switch (jackpotDescription) {
    case gameDescription.lottoOne:
      return replaceValues(schemaJackpotName.lottoOne);
    case gameDescription.lottoSecond:
      return replaceValues(schemaJackpotName.lottoSecond);
    case gameDescription.dreamWin:
      return replaceValues(schemaJackpotName.dreamWin);
    case gameDescription.eurojackpot:
      return replaceValues(schemaJackpotName.eurojackpot);
    case gameDescription.vikinglotto:
      return replaceValues(schemaJackpotName.vikinglotto);
    default:
      return reformattedText;
  }
};

var cleanTextAfterFormat = function cleanTextAfterFormat(reformattedText) {
  var regexFindAllCurlyBraces = /\{\{.*\}\}/gi;
  return reformattedText.replaceAll(regexFindAllCurlyBraces, '');
};

var createBannerJackpotAmount = function createBannerJackpotAmount(jackpotAmountString, defaultJackpot) {
  var jackpotAmount = parseInt(jackpotAmountString, 10);
  var prefixString = {
    fixedJackpot: 'minst',
    dynamicJackpot: 'ca'
  };
  var formatJackpotAmountString = function formatJackpotAmountString(formatAmount, jackpotString, doubleDigitJackpotString) {
    var formattedJackpotAmount = jackpotAmount / formatAmount;
    var formattedJackpotPrefix = defaultJackpot ? prefixString.fixedJackpot : prefixString.dynamicJackpot;
    var formattedJackpotSuffix = formattedJackpotAmount === 1 ? jackpotString : doubleDigitJackpotString;
    return "".concat(formattedJackpotPrefix, " ").concat(formattedJackpotAmount, " ").concat(formattedJackpotSuffix);
  };
  var formatAmounts = {
    million: 1000000,
    milliard: 1000000000
  };
  var valueString = {
    milliard: 'miljard',
    milliards: 'miljarder',
    million: 'miljon',
    millions: 'miljoner'
  };
  if (jackpotAmount >= formatAmounts.milliard) {
    return formatJackpotAmountString(formatAmounts.milliard, valueString.milliard, valueString.milliards);
  } else if (jackpotAmount >= formatAmounts.million) {
    return formatJackpotAmountString(formatAmounts.million, valueString.million, valueString.millions);
  }
  return jackpotAmountString;
};


var formatDynamicJackpotText = function formatDynamicJackpotText(_ref4) {
  var dynamicJackpotValues = _ref4.dynamicJackpotValues,
    bannerText = _ref4.bannerText,
    isHeading = _ref4.isHeading;
  var reformattedText = bannerText;
  var schemaJackpotName = isHeading ? editSchemaJackpotNameHeader : editSchemaJackpotNameBody;
  dynamicJackpotValues.forEach(function (jackpotObject) {
    if (jackpotObject !== null && jackpotObject !== void 0 && jackpotObject.jackpotAmount) {
      var jackpotAmountText = createBannerJackpotAmount(jackpotObject.jackpotAmount, jackpotObject.defaultJackpot) || '';
      var jackpotDescription = (jackpotObject === null || jackpotObject === void 0 ? void 0 : jackpotObject.description) || '';
      reformattedText = setDynamicValues(reformattedText, jackpotDescription, schemaJackpotName, jackpotAmountText);
    }
  });
  return cleanTextAfterFormat(reformattedText);
};

var dynamicValueExists = function dynamicValueExists(header, body) {
  var regexFindCurlyBraces = /\{\{.*\}\}/i;
  return regexFindCurlyBraces.test(header) || regexFindCurlyBraces.test(body);
};

var replaceDynamicJackpotValue = function () {
  var _ref5 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee4(req, logger) {
    var header,
      body,
      dynamicJackpotValues,
      _args4 = arguments;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          header = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : '';
          body = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : '';
          if (!dynamicValueExists(header, body)) {
            _context4.next = 8;
            break;
          }
          _context4.next = 5;
          return getJackpotDataBanner(req, logger);
        case 5:
          dynamicJackpotValues = _context4.sent;
          header = formatDynamicJackpotText({
            dynamicJackpotValues: dynamicJackpotValues,
            bannerText: header,
            isHeading: true
          });
          body = formatDynamicJackpotText({
            dynamicJackpotValues: dynamicJackpotValues,
            bannerText: body,
            isHeading: false
          });
        case 8:
          return _context4.abrupt("return", {
            reformattedHeading: header,
            reformattedBody: body
          });
        case 9:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function replaceDynamicJackpotValue(_x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();
if (svs.isServer) {
  module.exports = {
    replaceDynamicJackpotValue: replaceDynamicJackpotValue
  };
} else {
  svs.banner_common.banner_helpers.replaceDynamicJackpotValue = replaceDynamicJackpotValue;
}

 })(window);